import { jsx as _jsx } from "react/jsx-runtime";
import { Chip } from "@mui/material";
// The small count pill shown next to a card title (e.g. "Squad 12"). Renders
// nothing at zero, so callers don't need their own `> 0` guard.
export const CountChip = ({ count }) => {
    if (!count) {
        return null;
    }
    return (_jsx(Chip, { label: count, size: "small", sx: {
            backgroundColor: "rgba(25, 118, 210, 0.1)",
            color: "primary.main",
            fontWeight: 600,
            minWidth: 24,
        } }));
};
